import { createContext } from 'react';
import { DEFAULT_LOCALE } from './i18n';

export type PatientPortalContext = {
  keycloak?: Keycloak.KeycloakInstance;
  online?: boolean;
  locale: keyof mumms.translations;
  currentUser: mumms.User;
  patientsList: mumms.patient[];
  agency: string;
  appTitle?: string;
  smallWidget?: boolean;
  appError?: {
    status: number;
    statusText?: string;
    type?: string;
  };
  watermark?: {
    show: boolean;
    readOnly: boolean;
  };
  viewMode?: mumms.viewMode;
  printConfig?: mumms.printConfig;
  onWidgetReady?: (arg: mumms.ComponentName) => void;
  onClick?: () => void;
};

const initPatientPortalContext = {
  locale: DEFAULT_LOCALE,
};

export const PatientPortalContext = createContext<PatientPortalContext>(
  initPatientPortalContext as PatientPortalContext,
);
export const PatientPortalContextProvider = PatientPortalContext.Provider;
export const PatientPortalContextConsumer = PatientPortalContext.Consumer;
